import Footer from 'components/Layout/Footer/Footer';
import { AccessibilityNavigation } from 'components/Layout/Header/AccessibilityNavigation/AccessibilityNavigation';
import { Header } from 'components/Layout/Header/Header';
import { Webline } from 'components/Layout/Webline/Webline';
import useTranslation from 'next-translate/useTranslation';

const ErrorLayout: FC = ({ children }) => {
    const { t } = useTranslation();

    return (
        <>
            <AccessibilityNavigation />
            <div className="flex min-h-screen flex-col justify-between">
                <Webline style={{ marginBottom: '32px', position: 'relative' }} type="colored">
                    <Header simple />
                </Webline>
                <main aria-label={t('Error page content')} id="main-content">
                    {children}
                </main>
                <Webline type="light">
                    <Footer simple withoutMoveUpActionButton />
                </Webline>
            </div>
        </>
    );
};

/* @component */
export default ErrorLayout;
